
<template>
  <div>
    <router-view />
  </div>
</template>




<style>
#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
router-view {
  width: 100%;
}
</style>
